import RouterUtils from '../../../../shared/routing/RouterUtils';
import { ApiEndpoints } from '../../../../shared/webservices/endpoint';

export class WorkDetailRequest {

    _id; // string | number

    constructor() {
        this._id = -1;
    }

    setId(id) {
        this._id = id;
    }

    route() {
        return RouterUtils.generateRoute(ApiEndpoints.WORK_ID, { id: this._id });
    }

}



// WEBPACK FOOTER //
// ./src/app/my-contractors/work/detail/work-detail/WorkDetailRequest.js